<!-- <div class="wrapper_view" [style.backgroundColor]="value ? trueColor : falseColor" 
[style.width]="width" [style.height]="height" [style.borderColor]="borderColor">
    <span [style.color]="value ? trueTextColor : falseTextColor">{{ text }}</span>
</div> -->

<button 
  mat-raised-button
  [ngStyle]="{
    'background-color': value ? trueColor : falseColor,
    'color': value ? trueTextColor : falseTextColor,
    'width': width,
    'height': '30px',
    'border-color': borderColor
  }"
style="padding: 0; display: flex; align-items: center; justify-content: center;">
  <span style="color: white;">{{ text }}</span>
</button>